// Importación de Axios
import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

/*  
  
Crear

*/

export const getListasGenerales = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/cargarListas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
// Listar Shippings Instruction Por Enviar
export const getShippingInstructionsPorEnviar = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorEnviar`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Shipping Instruction Por Enviar Filtro
export const getShippingInstructionsPorEnviarFiltros = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorEnviar`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

//por aprobar
export const getShippingInstructionsPorAprobar = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorAprobar`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Shipping Instruction Por Aprobar Filtro
export const getShippingInstructionsPorAprobarFiltros = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorAprobar`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

//por realizar
export const getShippingInstructionsPorRealizar = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorRealizar`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Shipping Instruction Por realizar Filtro
export const getShippingInstructionsPorRealizarFiltros = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsPorRealizar`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

// Ver Shipping Instruction

export const verShippingInstruction = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/verShippingInstruction/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Ver Shipping Instruction post
export const verShippingInstructionPOST = async (id) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/verShippingInstruction`, id, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });
  dataAux.push(dataResponse);

  return dataAux[0];
};
//  Guardar Shipping Instruction
export const saveShippingInstructions = async form => {

  return await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearShippingInstruction`,
      form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

};

// Eliminar Shipping Instruction Por Enviar
export const deleteShipping = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarShippingInstruction/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const refreshRecharges = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();
  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/refreshRecharges/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Listar Shippings Instruction Enviadas
export const getShippingInstructionsEnviadas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsEnviadas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })

    .then(({ data }) => data);
export const getShippingInstructionsEnviadasFiltro = (form) =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsEnviadas`, form, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Listar Shippings Instruction Rechazadas
export const getShippingInstructionsRechazadas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsRechazadas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
export const getShippingInstructionsRechazadasFiltro = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsRechazadas`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

// Listar Shippings Instruction Confirmadas
export const getShippingInstructionsConfirmadas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsConfirmadas`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getShippingInstructionsConfirmadasFiltro = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsConfirmadas`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

// Listar Shippings Instruction Templates
export const getShippingInstructionsTemplates = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsTemplates`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getShippingInstructionsTemplatesFiltro = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsTemplates`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

// Listar Shippings Instruction Reportes
export const getShippingInstructionsReporte = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsReporte`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getShippingInstructionsReporteFiltro = (form) =>
  axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsTemplates`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(({ data }) => data);

export const listarNavesPorNaviera = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarNavesPorNaviera/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const listarViajesPorNaviera = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/listarViajesPorNaviera`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const listarBookingItineraryByBookingNumber = bookingNumber => {

  const isCharter = location.pathname.split("/")[1] === "charter" ? 1 : 0 ;

  return axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingItineraryByBookingNumber/${bookingNumber}/${isCharter}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);
}
export const editarShippingInstruction = form =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/editarShippingInstruction`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const listarShippingInstructionsRecord = id => axios
  .get(`${RUTA_SERVIDOR_BACKEND}/listarShippingInstructionsRecord/${id}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
  .then(({ data }) => data);

export const getTotalCountSteps = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getTotalCountSteps`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const getTotalCountStepsCharter = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getTotalCountStepsCharter`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const rejected = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/rejected/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const sendInttra = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/sendToInttra/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const sendToInttraBtn = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/sendToInttraBtn/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

export const downloadPdf = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/downloadPDFShippingInstruction/${id}`,
      {
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then((response) => response);

export const getReportShippingInstruction = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getReportShippingInstruction`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);


export const getReportShippingInstructionFiltro = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/getReportShippingInstruction`,
      form,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);
export const listarBookingItineraryByBookingItineraryId = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarBookingItineraryByBookingItineraryId/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({ data }) => data);

//shipping instructions por aprobar
export const aprobarShippingInstruction = id =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/si/approved/${id}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const aprobarMultiplesShippingInstructions = data =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/si/approveMultipleToApprove`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  ).then(({ data }) => data);

export const rechazarShippingInstruction = data =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/si/rejected`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => data);

export const realizar = id =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/si/check/${id}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const shippingInstructionsReport = (form) =>
  axios.post(`${RUTA_SERVIDOR_BACKEND}/shippingInstructions/report`,
    form,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => data);
